import { render, staticRenderFns } from "./StockInvoicePaymentsPanel.vue?vue&type=template&id=406a4f34&scoped=true"
import script from "./StockInvoicePaymentsPanel.vue?vue&type=script&lang=js"
export * from "./StockInvoicePaymentsPanel.vue?vue&type=script&lang=js"
import style0 from "./StockInvoicePaymentsPanel.vue?vue&type=style&index=0&id=406a4f34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406a4f34",
  null
  
)

export default component.exports